import React, { useState } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import {
    TextField,
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Grid,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    FormGroup,
    Box,
    Typography,
    Card,
    IconButton,
    CardHeader,
    CardContent,
    Divider,
    ThemeProvider,
    FormHelperText,
    Snackbar,
    Alert,
    CircularProgress,
    Breadcrumbs,
    Tooltip,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { styled } from "@mui/material/styles";
import EventIcon from "@mui/icons-material/Event";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { putUser, putUserPasswordReset } from "../../components/API/userAPI";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1e5d45", // Custom primary color
        },
    },
});


const StyledHr = styled("hr")(({ theme }) => ({
    border: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(4, 0),
    opacity: 0.8,
}));

function ResetPassword() {
    const [email, setEmail] = useState('')

    const [isLoading, setIsLoading] = useState(false);



    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmitClick = async () => {
        setIsLoading(true);

        await putUserPasswordReset(email)
        // Call the API to update the password
        // const result = await putUserPassword(id, newPassword);

        // if (result) {
        //     console.log("Password updated successfully:", result);
        //     alert("Password updated successfully!");
        // } else {
        //     console.error("Failed to update password.");
        //     alert("Failed to update password. Please try again.");
        // }

        setIsLoading(false);
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ padding: "40px 60px" }}>
                <Card
                    variant="outlined"
                    style={{
                        marginTop: "40px",
                        marginBottom: "40px",
                        borderRadius: 0,
                    }}
                >
                    <CardHeader
                        title={
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box display="flex" alignItems="center">
                                    <EventIcon
                                        sx={{
                                            fontSize: "40px",
                                            marginRight: "8px",
                                        }}
                                    />
                                    <Typography variant="h6">Reset Password</Typography>
                                </Box>

                            </Box>
                        }
                        sx={{
                            backgroundColor: "#1e5d45",
                            color: "white",
                            padding: "16px",
                        }}
                    />
                    <CardContent sx={{ padding: "20px" }}>
                        <Card variant="outlined" sx={{ padding: "20px" }}>
                            <CardHeader
                                title={
                                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                        Reset Password
                                    </Typography>
                                }
                                sx={{ marginBottom: 2 }}
                            />
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Email"
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)} // Update state to handle email
                                        size="small"
                                        required
                                        fullWidth
                                    />

                                </Grid>
                                <Grid item xs={4}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmitClick} // Attach the click handler
                                        disabled={isLoading} // Disable while loading
                                    >
                                        {isLoading ? "Submitting..." : "Submit"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                    </CardContent>
                </Card>
            </Box>
        </ThemeProvider>
    )

}

export default ResetPassword;